module.exports = __webpack_public_path__ + "img/alpha7.91e48b67.png";